import moment from 'moment';
import { GeodataAnalysis, GISFile, GISFileMessage } from '../models';
import { AppService } from './app';
import { HttpService } from './http';
import { UserService } from './user';
export class GISService {
  static async sendFile({
    partnerCode,
    ...props
  }) {
    try {
      const formData = new FormData();
      Object.keys(props).forEach(key => {
        const value = props[key];
        if (value) formData.append(key, typeof value === 'number' ? `${value}` : value);
      });
      const data = await HttpService.post('v1', '/sig_files', [], [], formData, {
        partner: partnerCode
      });
      return parseGisFileData(data);
    } catch (err) {
      console.error('[GISService][sendFile]', err);
      throw err;
    }
  }
  static async updateFile(fileId, {
    partnerCode,
    status
  }) {
    try {
      const params = {};
      if (status) params.status = backendStatuses[status];
      const data = await HttpService.patch('v1', `/sig_files/${fileId}`, [], [], JSON.stringify(params), {
        partner: partnerCode
      });
      return parseGisFileData(data);
    } catch (err) {
      console.error('[GISService][updateFile]', err);
      throw err;
    }
  }
  static async getFiles({
    partnerCode,
    fileType
  } = {}) {
    try {
      const params = [];
      if (fileType) params.push({
        key: 'file_type',
        value: fileType
      });
      const data = await HttpService.get('v1', '/sig_files', params, [], null, partnerCode ? {
        partner: partnerCode
      } : {});
      return data.map(parseGisFileData);
    } catch (err) {
      console.error('[GISService][getFiles]', err);
      throw err;
    }
  }
  static async getAnalysis({
    partnerCode,
    ordering,
    page,
    pageSize
  }) {
    try {
      const {
        count,
        results
      } = await HttpService.get('v1', '/geodata_analysis', [{
        key: 'ordering',
        value: ordering
      }, {
        key: 'page',
        value: page
      }, {
        key: 'page_size',
        value: pageSize
      }], [], null, partnerCode ? {
        partner: partnerCode
      } : {});
      return {
        count,
        analysis: results.map(parseGeodataAnalysis)
      };
    } catch (err) {
      console.error('[GISService][getAnalysis]', err);
      throw err;
    }
  }
  static async getFileMessages({
    fileId,
    query
  }) {
    try {
      const res = await HttpService.get('v1', `/sig_files/${fileId}/messages`, [{
        key: 'query',
        value: query
      }, {
        key: 'ordering',
        value: 'id'
      }]);
      return res.map(data => parseGisFileMessageData(data, AppService.environment.backendUrl));
    } catch (err) {
      console.error('[GISService][getFileMessages]', err);
      throw err;
    }
  }
  static async sendMessage({
    fileId,
    message,
    document
  }) {
    try {
      if (!UserService.currentUser) throw new Error('user not connected');
      const formData = new FormData();
      if (document) formData.append('document', document);
      formData.append('data', JSON.stringify({
        message
      }));
      const data = await HttpService.post('v1', `/sig_files/${fileId}/messages`, [], [], formData);
      return parseGisFileMessageData({
        ...data,
        creator: UserService.currentUser,
        created: moment().toISOString()
      }, AppService.environment.backendUrl);
    } catch (err) {
      console.error('[GISService][sendMessage]', err);
      throw err;
    }
  }
}
const statuses = {
  TO_DO: 'toDo',
  DOING: 'doing',
  STAND_BY: 'standby',
  DONE: 'done'
};
const backendStatuses = {
  toDo: 'TO_DO',
  doing: 'DOING',
  standby: 'STAND_BY',
  done: 'DONE'
};
function parseGisFileData({
  id,
  title,
  comment,
  document,
  status,
  created,
  creator,
  messages,
  type,
  geodata_analysis
}) {
  return new GISFile(id, title, comment, document, statuses[status], moment(created), creator, messages || [], type, geodata_analysis ? parseGeodataAnalysis(geodata_analysis) : null);
}
function parseGisFileMessageData({
  created,
  creator,
  message,
  attachment
}, backendUrl) {
  return new GISFileMessage(moment(created), creator, message, attachment ? `${backendUrl}${attachment}` : null);
}
function parseGeodataAnalysis({
  id,
  title,
  description,
  status,
  created,
  updated
}) {
  return new GeodataAnalysis(id, title || '', description || '', status, moment(created), moment(updated));
}